import React, { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { intersection, isString } from 'lodash';
import { Filter } from '@unite-us/app-components';

const ContractedProgramFilter = forwardRef(({
  options,
  selectedValues,
  setContractedProgramFilter,
  styles,
}, contractedProgramFilterRef) => {
  const onSelectFeeScheduleProgram = (selectedOptions) => {
    setContractedProgramFilter(selectedOptions.length > 0 ? selectedOptions.join(',') : undefined);
  };

  useEffect(() => {
    if (!contractedProgramFilterRef.current) return;

    if (!isString(selectedValues)) {
      contractedProgramFilterRef.current.setSelectedOptions([]);
      return;
    }

    const selectedIds = selectedValues.split(',');
    const selectedOptionValues = options
      .map((option) => option.value)
      .filter((values) => intersection(selectedIds, values.split(',')).length > 0);

    contractedProgramFilterRef.current.setSelectedOptions(selectedOptionValues);
  }, [options, selectedValues]);

  return (
    <>
      {(options.length > 0) ? (
        <div>
          <h5
            className="block mb-1 leading-snug font-extrabold font-medium-font normal-case text-13px text-text-blue"
          >
            Contracted Program
          </h5>
          <Filter
            filterKey="contracted-program"
            hideSelectAll
            id="contracted-program"
            name="Contracted Program"
            onFiltersChange={onSelectFeeScheduleProgram}
            options={options}
            ref={contractedProgramFilterRef}
            searchPlaceholder="Choose program"
            styles={styles}
          />
        </div>
      ) : (
        <div className="flex flex-col">
          <Skeleton height={20} width={250} />
          <Skeleton height={35} width={250} />
        </div>
      )}
    </>
  );
});

ContractedProgramFilter.defaultProps = {
  selectedValues: [],
  styles: {},
};

ContractedProgramFilter.propTypes = {
  options: PropTypes.array.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  setContractedProgramFilter: PropTypes.func.isRequired,
  styles: PropTypes.object,
};

export default ContractedProgramFilter;
